import "./App.css";

import { Navigate, createBrowserRouter, RouterProvider } from "react-router-dom";

import RootLayout from "./pages/RootLayout";
import { routes, Route } from "./routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ModalContextProvider } from "./components/ui/Modal/modal-context";
import { useAuthContext } from "./context/auth-context";

export const queryClient = new QueryClient();

const DefaultRedirect = () => {
  const { user } = useAuthContext();
  if (user?.role === "SUPERADMIN") {
    return <Navigate to={Route.settings} replace />;
  }
  return <Navigate to={Route.reserve} replace />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <div>Page Not Found (TODO)</div>,
    children: [
      {
        path: "/",
        element: <DefaultRedirect />,
      },
      ...Object.keys(routes).map((key) => ({
        path: key,
        ...routes[key],
      })),
    ],
  },
]);

function App() {
  return (
    <ModalContextProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ModalContextProvider>
  );
}

export default App;
